import { render, staticRenderFns } from "./ZoomTranscriptSidebar.vue?vue&type=template&id=aff8002a&scoped=true&"
import script from "./ZoomTranscriptSidebar.vue?vue&type=script&lang=js&"
export * from "./ZoomTranscriptSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ZoomTranscriptSidebar.vue?vue&type=style&index=0&id=aff8002a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8002a",
  null
  
)

export default component.exports